import React from "react";
import "./banner.scss";
import { Link } from "react-router-dom";
import Navbar from "../header/Navbar";
import { motion } from "framer-motion";
import Headernew from "../headernew/Headernew";
import ScheduleButton from "./ScheduleButton";

const Banner = () => {
  return (
    <section className="main-banner1">
      {/* <Navbar /> */}
      <Headernew />
      <video
        className="main-banner-video"
        muted
        playsInline
        autoPlay
        loop
        width="100%"
        id="myVideo"
      >
        <source src="/assets/bannervideo.mp4" type="video/mp4" />
      </video>

      <div className="custom-container1">
        <div className="top_banner">
          <motion.h3
            initial={{ x: -100, opacity: 0 }}
            whileInView={{ x: 0, opacity: 1 }}
            viewport={{ once: false }}
            transition={{ duration: 1, delay: 0 }}
          >
            Your Partner in IT, Automation, Security & Compliance
          </motion.h3>

          <div className="inner_sideetoo">
            <motion.p
              initial={{ x: -100, opacity: 0 }}
              whileInView={{ x: 0, opacity: 1 }}
              viewport={{ once: false }}
              transition={{ duration: 1, delay: 0.3 }}
            >
              We deliver intelligent IT solutions from Microsoft O365, SharePoint, and Azure administration to Power Automate workflows, managed infrastructure, and enterprise-grade InfoSec compliance. Secure, streamline, and scale your operations with confidence.
            </motion.p>

            <div className="button_side">
              <motion.button
                className="one"
                initial={{ x: -100, opacity: 0 }}
                whileInView={{ x: 0, opacity: 1 }}
                viewport={{ once: false }}
                transition={{ duration: 1, delay: 0.5 }}
              >
               <ScheduleButton />

              </motion.button>

              {/* <motion.button
                className="two"
                initial={{ x: -100, opacity: 0 }}
                whileInView={{ x: 0, opacity: 1 }}
                viewport={{ once: false }}
                transition={{ duration: 1, delay: 0.7 }}
              >
                Explore Portfolio
              </motion.button> */}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Banner;
